import { MessageBarType } from "@fluentui/react";
import { useState } from "react";
import { IDataResult, ResponseStatus, IResult } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { emptyFunc } from "../../home/models/OtherTypes";
import { createNewOrder, NewOrderModel } from "../models/OrderModel";
import { OrderAdminService } from "../services/OrderAdminService";
import { OrderService } from "../services/OrderService";

export function useNewOrderVM(isAdmin: boolean) {
    const orderService = isAdmin ? new OrderAdminService() : new OrderService();

    const [loading, setLoading] = useState(false);

    const {
        form,
        setForm,
        resetForm,
        setField,
        errorMessages,
        setErrorMessages,
        summaryText,
        setSummaryText,
        summaryType,
        setSummaryType
    } = useForm<NewOrderModel>(createNewOrder());

    const create = (callback: emptyFunc) => {
        //setField("customerId", customerId);
        setLoading(true);

        const request = orderService.create(form);
        DataUtils.onRequest(
            request,
            (result: IDataResult) => onCreateResult(result, callback)
        );
    }

    const onCreateResult = (result: IDataResult, callback: emptyFunc) => {
        if (!result.errorMessages) result.errorMessages = {};

        if (result.status === ResponseStatus.success) {
            resetForm();
            callback();
        }

        setLoading(false);

        const res = result as IResult
        if (res) { setErrorMessage(res); }
    }

    const setErrorMessage = (result: IResult) => {
        setErrorMessages(result.errorMessages);
        setSummaryText(result.summaryText ?? "");
        setSummaryType(result.summaryType ?? MessageBarType.info);
    }

    return {
        form,
        setForm,
        resetForm,
        setField,

        errorMessages,
        summaryText,
        summaryType,

        loading,
        create
    };
}